"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorValues2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/regeneratorValues.js"));
var _createForOfIteratorHelper2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js"));
var _regenerator2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/regenerator.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.splice.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.json.parse.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.number.to-fixed.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.set.js");
require("core-js/modules/es.set.difference.v2.js");
require("core-js/modules/es.set.intersection.v2.js");
require("core-js/modules/es.set.is-disjoint-from.v2.js");
require("core-js/modules/es.set.is-subset-of.v2.js");
require("core-js/modules/es.set.is-superset-of.v2.js");
require("core-js/modules/es.set.symmetric-difference.v2.js");
require("core-js/modules/es.set.union.v2.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.string.trim.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/web.url.js");
require("core-js/modules/web.url.to-json.js");
require("core-js/modules/web.url-search-params.js");
require("core-js/modules/web.url-search-params.delete.js");
require("core-js/modules/web.url-search-params.has.js");
require("core-js/modules/web.url-search-params.size.js");
var _attachFile = require("@/api/system/attachFile");
var _cloud = require("@/utils/cloud");
var _auth = require("@/utils/auth");
var _axios = _interopRequireDefault(require("axios"));
var _index = _interopRequireDefault(require("@components/wl-component-gallery/wl-dialog-row-detail/index.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Attach',
  components: {
    wlDialogRowDetail: _index.default
  },
  props: {
    menuRoute: {
      type: String,
      default: ''
    },
    formId: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      rowRules: {},
      // 行表单校验
      rowItem: [],
      // 行对话框输入控件
      rowDetailsForm: {},
      // 行对话框表单数据对象
      rowNo: 0,
      // 行索引
      rowDetailsVisible: false,
      // 行对话框表单显示状态
      showModalFlag: false,
      modalImage: '',
      attachList: [],
      // 文件列表
      deleteId: [],
      // 文件删除ID表
      // 总条数
      total: 0,
      // 查询参数
      queryParams: {
        formId: undefined,
        menuRoute: undefined,
        attSource: undefined
      },
      attSource: undefined,
      uploadAction: process.env.VUE_APP_BASE_API + _cloud.urls.projectName + '/sys/attach-file/uploadFile',
      headers: {
        Authorization: 'Bearer ' + (0, _auth.getToken)()
      },
      attachSourceOption: [],
      visible: false,
      activeTab: 'attach',
      images: [
        // 更多图片URL
      ],
      loading: false,
      submitting: false
    };
  },
  created: function created() {
    var _this = this;
    if (this.showModalFlag) {
      // this.getFileList()
      this.getList(this.formId, this.menuRoute, this.attSource);
      this.getDicts('attach_source').then(function (response) {
        _this.attachSourceOption = response.data;
      });
    }
  },
  methods: {
    // 打开明细表格
    handleRowDbClick: function handleRowDbClick(row) {
      var _this2 = this;
      var rowIndex = this.attachList.indexOf(row);
      if (isNaN(rowIndex) || rowIndex == -1) {
        console.log('获取行索引失败');
      }
      this.rowNo = rowIndex;
      this.rowDetailsVisible = true;
      this.rowDetailsForm = JSON.parse(JSON.stringify(row));
      this.rowItem = [{
        tab: '附件明细',
        fields: [{
          code: 'attName',
          label: '名称',
          type: 'input'
        }, {
          code: 'attFormat',
          label: '格式',
          type: 'input'
        }, {
          code: 'attSize',
          label: '文件大小',
          type: 'input',
          disabled: true
        }, {
          code: 'attVersion',
          label: '版本',
          type: 'input'
        }, {
          code: 'attSource',
          label: '来源',
          type: 'status',
          options: function () {
            var _options = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
              return (0, _regenerator2.default)().w(function (_context) {
                while (1) switch (_context.n) {
                  case 0:
                    _context.n = 1;
                    return _this2.$$getDict('attach_source');
                  case 1:
                    return _context.a(2, _context.v);
                }
              }, _callee);
            }));
            function options() {
              return _options.apply(this, arguments);
            }
            return options;
          }()
        }]
      }, {
        tab: '备注',
        fields: [{
          template: 'remark',
          label: '备注',
          code: 'remark',
          control: {
            autosize: {
              minRows: 5,
              maxRows: 8
            }
          },
          type: 'textarea',
          grid: 23
        }]
      }];
      this.rowRules = {};
    },
    // 处理表单修改数据并回调
    onRowOk: function onRowOk(rowDetail, rowNo) {
      if (isNaN(rowNo) || rowNo == -1) {
        console.log('获取行索引失败');
      }
      this.$set(this.attachList, rowNo, rowDetail);
    },
    // 关闭明细弹框
    closeRowDetailsDialog: function closeRowDetailsDialog() {
      this.resetForm('rowDetailsForm');
      this.rowItem = [];
      this.rowNo = 0;
      this.rowRules = {};
      this.rowDetailsVisible = false;
    },
    showModal: function showModal(image) {
      this.modalImage = image;
      this.showModalFlag = true;
    },
    closeModal: function closeModal() {
      this.showModalFlag = false;
    },
    // 获取文件列表
    getFileList: function getFileList() {
      var _this3 = this;
      (0, _attachFile.getFileList)(this.menuRoute, this.formId).then(function (res) {
        _this3.images = res;
      });
    },
    handleBeforeUpload: function handleBeforeUpload(file) {
      // this.filesToUpload.push(file)
      return false; // 阻止自动上传,在点击确定的时候再保存
    },
    handleUpload: function handleUpload() {
      return this.checkAndUploadFiles();
    },
    checkAndUploadFiles: function checkAndUploadFiles() {
      var _this4 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var h, errMsg, nameSet, _iterator, _step, file, n, name, res;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this4.loading = true;
              h = _this4.$createElement;
              errMsg = [];
              nameSet = new Set();
              if (_this4.attachList.length === 0) {
                errMsg.push(h('p', '上传文件不能为空！'));
              }
              _iterator = (0, _createForOfIteratorHelper2.default)(_this4.attachList);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  file = _step.value;
                  if (nameSet.has(file.attName)) {
                    errMsg.push(h('p', '存在同名文件' + file.attName));
                  }
                  nameSet.add(file.attName);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              n = 0;
            case 1:
              if (!(n < _this4.attachList.length)) {
                _context2.n = 4;
                break;
              }
              if (_this4.attachList[n].id) {
                _context2.n = 3;
                break;
              }
              name = _this4.attachList[n].attName + '_' + _this4.attachList[n].attVersion;
              _context2.n = 2;
              return (0, _attachFile.getFileName)(_this4.menuRoute, name);
            case 2:
              res = _context2.v;
              if (!(res.data === true)) {
                _context2.n = 3;
                break;
              }
              errMsg.push(h('p', '已存在文件' + name));
              return _context2.a(3, 4);
            case 3:
              n++;
              _context2.n = 1;
              break;
            case 4:
              if (!(errMsg.length > 0)) {
                _context2.n = 5;
                break;
              }
              _this4.$notify({
                title: '校验不通过',
                type: 'warning',
                message: h('div', {
                  style: 'color: teal;white-space: pre-wrap;'
                }, errMsg)
              });
              _this4.loading = false;
              throw new Error('校验失败');
            case 5:
              _context2.n = 6;
              return _this4.uploadFiles();
            case 6:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    uploadFiles: function uploadFiles() {
      var _this5 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var i, uploadPromises, _loop, _i;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _this5.loading = true;
              // 先进行版本校验
              i = 0;
            case 1:
              if (!(i < _this5.attachList.length)) {
                _context4.n = 3;
                break;
              }
              if (_this5.attachList[i].attVersion) {
                _context4.n = 2;
                break;
              }
              _this5.$message.warning('请输入版本！');
              _this5.loading = false;
              throw new Error('版本为空');
            case 2:
              i++;
              _context4.n = 1;
              break;
            case 3:
              // 收集所有需要上传的文件任务
              uploadPromises = [];
              _loop = /*#__PURE__*/(0, _regenerator2.default)().m(function _loop(_i) {
                var file, formData, promise;
                return (0, _regenerator2.default)().w(function (_context3) {
                  while (1) switch (_context3.n) {
                    case 0:
                      file = _this5.attachList[_i].raw;
                      if (file) {
                        formData = new FormData();
                        formData.append('menuRoute', _this5.menuRoute);
                        formData.append('formId', _this5.formId);
                        formData.append('attVersion', _this5.attachList[_i].attVersion);
                        formData.append('file', file);
                        promise = _axios.default.post(process.env.VUE_APP_BASE_API + _cloud.urls.projectName + '/sys/attach-file/uploadFile', formData, {
                          headers: {
                            'Content-Type': 'multipart/form-data',
                            Authorization: 'Bearer ' + (0, _auth.getToken)()
                          }
                        }).then(function () {
                          // 上传成功后更新文件名
                          var fileName = file.name;
                          var fileExtension = fileName.substring(fileName.lastIndexOf('.'));
                          var originalFileName = fileName.substring(0, fileName.lastIndexOf('.'));
                          _this5.attachList[_i].attName = _this5.formId + '_' + originalFileName + '_' + _this5.attachList[_i].attVersion + fileExtension;
                        });
                        uploadPromises.push(promise);
                      }
                    case 1:
                      return _context3.a(2);
                  }
                }, _loop);
              });
              _i = 0;
            case 4:
              if (!(_i < _this5.attachList.length)) {
                _context4.n = 6;
                break;
              }
              return _context4.d((0, _regeneratorValues2.default)(_loop(_i)), 5);
            case 5:
              _i++;
              _context4.n = 4;
              break;
            case 6:
              _context4.n = 7;
              return Promise.all(uploadPromises);
            case 7:
              _context4.n = 8;
              return _this5.saveAttach(_this5.attachList);
            case 8:
              return _context4.a(2);
          }
        }, _callee3);
      }))();
    },
    // 改为传参，方便父组件直接调用这个方法
    saveAttach: function saveAttach(attachList) {
      var _this6 = this;
      this.loading = true;
      // 处理删除ID
      var cleanedIds = this.deleteId.map(function (id) {
        return id.replace(/[‘’]/g, "'");
      });
      var filteredIds = cleanedIds.filter(function (id) {
        return id.trim() !== '';
      });
      var deletePromise = Promise.resolve();
      if (filteredIds.length > 0) {
        deletePromise = (0, _attachFile.del)(filteredIds.join(','));
      }
      return deletePromise.then(function (res) {
        if (res && res.code != 200) {
          throw new Error('删除失败');
        }
        return (0, _attachFile.submit)(attachList);
      }).then(function (response) {
        if (response.code == 200) {
          _this6.visible = false;
          _this6.$message.success('保存成功');
        } else {
          throw new Error('保存失败');
        }
      }).catch(function (err) {
        _this6.$message.error(err.message || '保存失败');
        throw err; // 继续抛出，让上层处理
      }).finally(function () {
        _this6.loading = false;
      });
    },
    updateAttach: function updateAttach(attachList) {
      var _this7 = this;
      this.loading = true;
      // 假设 this.deleteId 包含非标准引号字符的字符串数组
      var cleanedIds = this.deleteId.map(function (id) {
        return id.replace(/[‘’]/g, "'");
      }); // 清理非标准引号字符

      var filteredIds = cleanedIds.filter(function (id) {
        return id.trim() !== '';
      });
      if (filteredIds.length > 0) {
        (0, _attachFile.del)(filteredIds.join(',')).then(function (res) {
          if (res.code != 200) {
            _this7.loading = false;
          }
        });
      }
      (0, _attachFile.update)(attachList);
    },
    // 附件删除
    handleDelete: function handleDelete(index, row) {
      if (row.id) {
        this.deleteId.push(row.id);
      }
      this.attachList.splice(index, 1);
      this.msgSuccess('删除成功');
    },
    handleExceed: function handleExceed(files, attachList) {
      this.$message.warning("\u5F53\u524D\u9650\u5236\u9009\u62E9 5 \u4E2A\u6587\u4EF6\uFF0C\u672C\u6B21\u9009\u62E9\u4E86 ".concat(files.length, " \u4E2A\u6587\u4EF6\uFF0C\u5171\u9009\u62E9\u4E86 ").concat(files.length + attachList.length, " \u4E2A\u6587\u4EF6"));
    },
    beforeRemove: function beforeRemove(file, attachList) {
      return this.$confirm("\u786E\u5B9A\u79FB\u9664 ".concat(file.name, "\uFF1F"));
    },
    handleChange: function handleChange(file, attachList) {
      var items = {
        attName: this.formId + '_' + file.name,
        attSize: (file.size / 1024).toFixed(2) + 'kb',
        attUid: file.uid,
        raw: file.raw,
        attFormat: file.name.split('.')[1],
        attSource: this.attSource,
        menuRoute: this.menuRoute,
        formId: this.formId,
        attVersion: ''
      };
      this.attachList.push(items);
    },
    handleView: function handleView(row) {},
    handleDownload: function handleDownload(row) {
      (0, _axios.default)({
        method: 'get',
        url: process.env.VUE_APP_BASE_API + _cloud.urls.projectName + '/sys/attach-file/downloadFile',
        params: {
          url: row.url,
          attName: row.attName
        },
        headers: {
          Authorization: 'Bearer ' + (0, _auth.getToken)() // 添加请求头中的 Authorization
        },
        responseType: 'blob' // 指定响应类型为blob，以获取二进制文件数据
      }).then(function (response) {
        var blob = new Blob([response.data], {
          type: response.headers['content-type']
        });
        // 创建一个可下载的URL
        var downloadUrl = URL.createObjectURL(blob);
        // 创建一个隐藏的<a>元素，并设置其属性
        var link = document.createElement('a');
        link.href = downloadUrl;
        link.download = row.attName; // 替换为要下载的文件名
        // 将<a>元素添加到页面中，并模拟点击以触发下载
        document.body.appendChild(link);
        link.click();
        // 下载完成后，记得移除<a>元素
        document.body.removeChild(link);
      }).catch(function (error) {
        // 处理错误情况
        console.error('Error:', error);
      });
    },
    // 字典状态字典翻译
    statusFormat: function statusFormat(row, column) {
      return this.selectDictLabel(this.attachSourceOption, row.attSource);
    },
    closeDialog: function closeDialog() {
      this.visible = false;
      this.submitting = false; // 重置提交状态
      this.deleteId = [];
      // this.formId=''
      // this.menuRoute=''
      this.attachList = [];
      this.images = [];
    },
    handleSubmit: function handleSubmit() {
      var _this8 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4() {
        var _t;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              if (!_this8.submitting) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              _this8.submitting = true;
              _context5.p = 2;
              _context5.n = 3;
              return _this8.handleUpload();
            case 3:
              _context5.n = 5;
              break;
            case 4:
              _context5.p = 4;
              _t = _context5.v;
            case 5:
              _context5.p = 5;
              _this8.submitting = false;
              return _context5.f(5);
            case 6:
              return _context5.a(2);
          }
        }, _callee4, null, [[2, 4, 5, 6]]);
      }))();
    },
    openDialog: function openDialog(type) {
      this.deleteId = [];
      // this.attachList=[]
      this.visible = true;
      this.attSource = type;
      this.getList(this.formId, this.menuRoute, this.attSource);
    },
    // 查询列表  改为传参，方便父组件直接调用这个方法
    getList: function getList(formId, menuRoute, attSource) {
      var _this9 = this;
      this.loading = true;
      this.queryParams.formId = formId;
      this.queryParams.menuRoute = menuRoute;
      this.queryParams.attSource = attSource;
      (0, _attachFile.listAttach)(this.queryParams).then(function (response) {
        _this9.attachList = response;
        _this9.loading = false;
        _this9.$parent.attachList = response;
      }).catch(function (err) {
        _this9.loading = false;
        _this9.$message.warning('查询失败');
      }).finally(function () {
        // this.loading = false
      });
    },
    // 获取来源单据文件并回调
    getSourceList: function getSourceList(formId, menuRoute, attSource) {
      var _this0 = this;
      this.loading = true;
      var query = {
        formId: formId,
        menuRoute: menuRoute,
        attSource: attSource
      };
      (0, _attachFile.listAttach)(query).then(function (response) {
        // console.log('response',response)
        _this0.$emit('handle-source-attach-List', response);
      }).catch(function (err) {
        _this0.loading = false;
        _this0.$message.warning('查询失败');
      }).finally(function () {
        // this.loading = false
      });
    },
    /** 搜索按钮操作 */handleQuery: function handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList(this.formId, this.menuRoute, this.attSource);
    },
    /** 重置按钮操作 */resetQuery: function resetQuery() {
      this.queryParams.attName = undefined;
      this.queryParams.attSource = undefined;
      this.resetForm('queryForm');
      this.handleQuery();
    }
  }
};